module.exports = __webpack_public_path__ + "img/wzys.8739409f.png";